<template>
    <v-content>
        <div>
            <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
            <div slot="table-actions">
                <div class="my-1">
                    <v-row>
                        <v-col md="5"></v-col>
                        <v-col md="2">
                            <v-select v-model.number="levelID" dense outlined
                                      :items="levels"
                                      item-text="text"
                                      item-value="value">
                                <template v-slot:label>
                                    {{ $t("level") }}
                                </template>
                            </v-select>
                        </v-col>
                        <v-col md="2">
                            <v-select v-model.number="fiscalYearID" dense outlined
                                      :items="fiscalYearList"
                                      item-text="text"
                                      item-value="value">
                                <template v-slot:label>
                                    {{ $t("fiscal_year") }}
                                </template>
                            </v-select>
                        </v-col>
                        <v-col md="1">
                            <v-btn color="primary" v-if="fiscalYearID>0 && levelID>0" @click.stop="search">{{$t('search')}}</v-btn>
                        </v-col>
                        <v-col md="1" v-if="incomeExpensesReportList.length > 0">
                            <v-btn @click="exportToExcelWithRowspanColspan('IncomeExpensesReport')" class="white--text" color="green">
                                <v-icon>mdi-cloud-download</v-icon>
                                Export
                            </v-btn>
                        </v-col>

                    </v-row>
                </div>
            </div>
            <div style="text-align:center">
                <h3> खाद्य व्यवस्था तथा व्यापार कम्पनी लिमिटेड</h3>
                <h3 v-if="levelID==0"> आ.ब {{fiscalyearName}} को लागि आय श्रोत तथा खर्चको अनुमान</h3>
                <h3 v-if="levelID==1"> आ.ब पहिलो तह {{fiscalyearName}} को लागि आय श्रोत तथा खर्चको अनुमान</h3>
                <h3 v-if="levelID==2"> आ.ब दोस्रो तह {{fiscalyearName}} को लागि आय श्रोत तथा खर्चको अनुमान</h3>
                <h3 v-if="levelID==3"> आ.ब तेस्रो तह {{fiscalyearName}} को लागि आय श्रोत तथा खर्चको अनुमान</h3>
            </div>
            <v-card-text>


                <table ref="myTable" id="myTable" style="border-collapse:collapse;">
                    <thead>
                        <tr>
                            <th colspan="7" style="visibility: hidden;">
                                <h3> खाद्य व्यवस्था तथा व्यापार कम्पनी लिमिटेड</h3>
                            </th>
                        </tr>
                        <tr>
                            <th colspan="7" style="visibility: hidden;">
                                <h3> आ.ब {{fiscalyearName}} को लागि आय श्रोत तथा खर्चको अनुमान</h3>
                            </th>
                        </tr>
                        <tr>
                            <th class="header-cell" rowspan="2">क्र.सं</th>
                            <th class="header-cell" rowspan="2">विवरण</th>
                            <th class="header-cell" rowspan="2">अनुमानित आम्दानी</th>
                            <th class="header-cell" rowspan="2">विषय</th>
                            <th class="header-cell" colspan="2">अनुमानित खर्च</th>
                            <th class="header-cell" rowspan="2">जम्मा</th>
                        </tr>
                        <tr>
                            <th class="header-cell">चालु</th>
                            <th class="header-cell">पूँजीगत</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, itemIndex) in incomeExpensesReportList" :key="itemIndex">
                            <td class="header-cell subject-background">{{itemIndex +1}}</td>
                            <td class="header-cell subject-background" style="text-align:left !important">{{item.incomeSubjectTitleName}}</td>
                            <td class="header-cell subject-background">{{item.incomeAmount}}</td>
                            <td class="header-cell subject-background" style="text-align:left !important">{{item.expensesSubjectTitleName}}</td>
                            <td class="header-cell subject-background">{{item.currentAmount}}</td>
                            <td class="header-cell subject-background">{{item.capitalAmount}}</td>
                            <td class="header-cell subject-background">{{item.totalAmount}}</td>
                        </tr>
                        <tr>
                            <th class="header-cell subject-background-total" colspan="2">
                                <strong>
                                    जम्मा
                                </strong>
                            </th>
                            <th class="header-cell subject-background-total"><strong>{{ subjectTotal.incomeAmount }}</strong></th>
                            <th class="header-cell subject-background-total">
                                <strong>
                                    जम्मा
                                </strong>
                            </th>
                            <th class="header-cell subject-background-total"><strong>{{ subjectTotal.currentAmount }}</strong></th>
                            <th class="header-cell subject-background-total"><strong>{{ subjectTotal.capitalAmount}}</strong></th>
                            <th class="header-cell subject-background-total"><strong>{{ subjectTotal.totalAmount}}</strong></th>
                        </tr>
                    </tbody>


                </table>
            </v-card-text>

            <v-snackbar v-model="snackbar.snackbar"
                        :color="snackbar.color"
                        :timeout="snackbar.timeout"
                        top>
                {{ snackbar.text }}
                <v-btn dark
                       text
                       @click="snackbar.snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>
        </div>
    </v-content>
</template>

<script>
    import { excelExport } from "../../../../mixins/excelExport";

    import axios from "axios";
    export default {
        name: "ReportList",
        components: {
        },
        mixins: [excelExport],
        data() {
            return {
                role: this.$store.getters.getUserRole,
                fiscalyearName: "",
                columns: [
                    {
                        label: "fiscal_year",
                        field: "fiscalYearName"
                    },
                    {
                        label: "actions",
                        field: "actions",
                        sortable: false
                    }
                ],
                rows: [],
                levels: [
                    { text: "पहिलो तह", value: 1 },
                    { text: "दोस्रो तह", value: 2 },
                    { text: "तेस्रो तह", value: 3 },
                ],
                incomeExpensesReportList: [],
                fiscalYearList: [],
                fiscalYearID: 0,
                levelID: 0,
                subjectFormData: {},
                subjectReportViewData: {},
                customerData: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "fiscalYearID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 15
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    reportformModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    viewFormComponent: false,
                    dialogDelete: false,
                    breadcrumbItems: [
                        {
                            text: 'dashboard',
                            disabled: false,
                            to: 'superAdminDashboard',
                        },
                        {
                            text: 'Subject Title',
                            disabled: true,
                        },
                    ],
                    dynamicComponent: {
                        current: 'SectionsForm'
                    }
                }
            };
        },
        computed: {
            breadcrumbItems() {

                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: 'superAdminDashboard',
                        exact: true
                    },
                    {
                        text: this.$t('income_expenses_report'),
                        disabled: true,
                    },
                ]
            },
            subjectTotal() {
                const sumData = {
                    incomeAmount: 0,
                    currentAmount: 0,
                    capitalAmount: 0,
                    totalAmount: 0
                }
                this.incomeExpensesReportList.map(res => {
                    sumData.incomeAmount += res.incomeAmount == null ? 0 : res.incomeAmount
                    sumData.currentAmount += res.currentAmount == null ? 0 : res.currentAmount 
                    sumData.capitalAmount += res.capitalAmount == null ? 0 : res.capitalAmount
                    sumData.totalAmount += res.totalAmount == null ? 0 : res.totalAmount
                })
                sumData.incomeAmount = Number(sumData.incomeAmount.toFixed(3));
                sumData.currentAmount = Number(sumData.currentAmount.toFixed(3));
                sumData.capitalAmount = Number(sumData.capitalAmount.toFixed(3));
                sumData.totalAmount = Number(sumData.totalAmount.toFixed(3));
                return sumData
            },
        },

        methods: {
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
                let model = {
                    fiscalYearID: this.fiscalYearID,
                }
                this.subjectFormData = model;

                this.snackbar.createFormComponent
                    this.$refs.subjectForm.loadItems();
            },


            reportItem(item) {
                this.snackbar.reportformModal = true
                this.snackbar.viewFormComponent = true
                let model = {
                    fiscalYearID: item.fiscalYearID,
                }
                this.subjectReportViewData = model;

                this.snackbar.viewFormComponent
                this.$refs.subjectReportView.loadItems();
            },

            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
                let model = {
                    fiscalYearID: item.fiscalYearID,
                }
                this.subjectFormData = model;

                this.snackbar.createFormComponent
                    this.$refs.subjectForm.loadItems();
            },
            deleteItemRoom(item) {
                this.snackbar.dialogDelete = true;
                this.customerData.deleteFormData.url = "ReportSettings/DeleteIncomeBudgetLevelOne/" + item.fiscalYearID;
                this.loadItems();
            },
            onResponseDelete() {
                this.snackbar.dialogDelete = false;
                this.loadItems();
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
                this.loadItems();
            },
            dialogueClose() {
                this.customerData.editItemIndex = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
                this.snackbar.viewFormComponent = false
                this.loadItems()
            },
            dialogueCloseView() {
                this.snackbar.reportformModal = false
                this.snackbar.viewFormComponent = false
            },
            search() {
                this.snackbar.isLoading = true;
                this.fiscalYearName()
                axios.post('ReportSettings/GetIncomeExpensesReportList/' + this.fiscalYearID + '/' + this.levelID).then(response => {
                    this.incomeExpensesReportList = response.data
                })
            },
            async loadItems() {
                this.snackbar.isLoading = true;
                let param = {
                    PageSize: this.serverParams.perPage == -1 ? this.customerData.totalRecords : this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                };
                axios.post('ReportSettings/IncomeLevelOneList', param).then(response=>{
                    this.rows = response.data.data
                    this.customerData.totalRecords = response.data.totalCount
                })
            },
            fiscalYearName() {
                axios.get("ReportSettings/FiscalYearName/" + this.fiscalYearID).then(response => {
                    this.fiscalyearName = response.data
                })
            },
            fiscalyear() {
                axios.get("ReportSettings/GetFiscalYearList").then(response => {
                    this.fiscalYearList = response.data
                })
                
            }
        },
        mounted() {
            this.loadItems()
            this.fiscalyear()
        },

        
    }
</script>

<style scoped>
    .subject-background {
        background-color: white;
    }
    .subject-background-total {
        background-color: #abaed366
    }
</style>
